// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const deleteAlertApi = (alertId) => api().delete(`/alerts/${alertId}`);

export default deleteAlertApi;
